module.exports = __webpack_public_path__ + "static/media/bulk_ppc_sample.e8488f97.csv";